import { usePermission } from '@/hooks/usePermission';
import { useActiveCompany } from '@/lib/active-company-context';

import { DASHBOARD_PERMISSION, useDashboardSummary } from './use-dashboard';

// Salud documental del menú lateral (so=430, spec §3.7 y D8): lee el mismo resumen del
// panel (misma clave de caché, una sola consulta). Sin permiso, sin empresa, cargando o
// con error devuelve null: el menú no muestra un número que no sea real.

export interface DocumentHealth {
  controlled: number;
  currentPct: number | null;
  overdue: number;
}

export function useDocumentHealth(): DocumentHealth | null {
  const allowed = usePermission(DASHBOARD_PERMISSION);
  const { activeCompanyId } = useActiveCompany();
  const { data } = useDashboardSummary({ companyId: activeCompanyId, enabled: allowed });
  if (!allowed || data === undefined) {
    return null;
  }
  return {
    controlled: data.controlled.total,
    currentPct: data.current.pct,
    overdue: data.overdue.documents,
  };
}
